import * as types from '../constants'
import callAPI from '../callAPI/callAPI'

export const getAllComment = (comments) => {
    return {
        type: types.GET_ALL_COMMENT,
        payload: comments
    }
}

export const fetchAPIAllComment = () => {
    return dispatch => {
        return callAPI('comments', 'GET', null).then(res => {
            dispatch(getAllComment(res.data))
        })
    }
}

export const replyComment = (comment) => {
    return {
        type: types.REPLY_COMMENT_USER,
        payload: comment
    }
}

export const fetchAPIReplyComment = (comment) => {
    return dispatch => {
        return callAPI(`comments/${comment.id}`, 'PUT', comment).then(res => {
            dispatch(replyComment(res.data))
            dispatch(fetchAPIAllComment())
        })
    }
}

export const deleteComment = (id) => {
    return {
        type: types.DELETE_COMMENT,
        payload: id
    }
}

export const fetchAPIDeleteComment = (id) => {
    return dispatch => {
        return callAPI(`comments/${id}`, 'DELETE', null).then(res => {
            dispatch(deleteComment(id));
            dispatch(fetchAPIAllComment())
        })
    }
}